module.exports = __webpack_public_path__ + "img/EPalintonon64_ua.3e7a4d3f.webp";